import React from 'react'
import {SkeletonLoader} from 'oolib'


export const AuthLinksLoader = () => {
    return <li style={{padding: '0 2rem 0 1rem'}}>
        <SkeletonLoader style={{ height: '3rem', width: '3rem', borderRadius: '50%'}} />
    </li>
}